<template lang="pug" src="./hero.pug"></template>

<script>
import Icon from 'components/icon/icon'

export default {
  props: ['props'],
  data () {
    return {
      slide: false,
      currSlide: 0,
      switchSize: 0
    }
  },
  mounted () {
    setTimeout(() => {
      this.slide = true
      this.switchSize++
    }, 100)
    setInterval(() => {
      this.currSlide === this.props.images.length - 1 ? this.currSlide = 0 : this.currSlide++
      this.switchSize++
    }, 7500)
  },
  components: {
    Icon
  }
}
</script>



// WEBPACK FOOTER //
// hero.vue?7a5a11e4